import { fetchBackend } from '@/utils/fetch'

/**
 * 获取当前用户的菜单配置
 */
export const getMenuList = () => fetchBackend.get('/pe/gatekeeper/node/api/v1/menu/config', {})
